import { render, staticRenderFns } from "./key-figures.vue?vue&type=template&id=08e24c3d"
import script from "./key-figures.vue?vue&type=script&lang=js"
export * from "./key-figures.vue?vue&type=script&lang=js"
import style0 from "./key-figures.vue?vue&type=style&index=0&id=08e24c3d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./key-figures.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PageHero: require('/vercel/path0/components/PageHero.vue').default})
